export const environment = {
  MODE: import.meta.env.MODE,
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
  PASSCODE: import.meta.env.VITE_PASSCODE,
  USER_JWT:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Im1hcmN1c2NoZW5AZ21haWwuY29tIiwidXNlclR5cGUiOiJDUkVBVE9SIiwiaWF0IjoxNzUyODY5NjI0LCJleHAiOjE3NTQwNzkyMjR9.qvn5Plvzftqu68ii8oYURRhpxO_QIMqk7NkB4SYiSvw",
  BRAND_JWT:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImJyYW5kdGVzdEBnbWFpbC5jb20iLCJ1c2VyVHlwZSI6IkJSQU5EX1VTRVIiLCJicmFuZElkIjoidGVzdCIsImlhdCI6MTc1Mjg2OTYyNCwiZXhwIjoxNzU0MDc5MjI0fQ.rgEBpLYSnoOmxyeSrZG0LGorfKXkSG8YUnjHA6q1Zws",
};

export const StripeEnvironment = {
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
};
